<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item">
        <md-card class="md-card-plain">
          <md-card-header>
            <h4 class="title">Error 404 Not Found</h4>
          </md-card-header>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>
